const riot = require('riot');

riot.tag2('page-settings', '<div class="s-full f"> <div class="w0 flex-auto f fclm bg-pale_gray"> <div class="bg-white" data-is="module-page-header" title="アカウント設定" back="{true}"></div> <div class="px40 pt36"> <form class="s-full f fclm bg-white rounded-8 elevation-default-low" onsubmit="{onUpdateUser}"> <div class="section-padding"> <div class="mb24"> <label class="inline-block"> <div class="ts-hxs mb8">アカウント名</div> <input class="input w500" ref="name" type="text" placeholder="アカウント名" required riot-value="{app.utils.auth.currentUser.name}" oninput="{dataChange}"> </label> </div> <div class="mb24"> <label class="inline-block"> <div class="ts-hxs mb8">メールアドレス</div> <input class="input w500" ref="email" placeholder="メールアドレス" required riot-value="{app.utils.auth.currentUser.email}" oninput="{dataChange}" type="{\'email\'}"> </label> </div> </div> <div data-is="module-section-footer" buttons="{buttons}"> </div> </form> </div> </div> </div>', 'page-settings,[data-is="page-settings"]{display:block}', '', function(opts) {
    this.buttons = [
      {
        type: 'submit',
        text: '保存',
        class: 'outline',
      },
    ];

    this.head = () => {
      return {
        title: app.utils.head.title('ユーザー設定', this),
      };
    };

    this.on('show', () => {
      this.reset();
    });

    this.on('beforeunload', async (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.dataChange = () => {
      this.isChange = true;
    };

    this.onUpdateUser = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      var params = {
        name: this.refs.name.value,
        email: this.refs.email.value,
      };
      try {
        var {user} = await app.api.child(`users/${app.utils.auth.currentUser.id}`).put(params);
        app.utils.auth.currentUser = user;
        this.reset();
        spat.modal.alert('更新が完了しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.reset = () => {
      this.isChange = false;
      this.refs.name.value = app.utils.auth.currentUser.name;
      this.refs.email.value = app.utils.auth.currentUser.email;
      this.update();
    };
});